import React, { useState } from "react";
import * as Icon from 'react-feather';
import { useSelector } from "react-redux";
import { MdAlignVerticalBottom } from "react-icons/md";
import { BiStats,BiTrendingUp,BiTransfer,BiMoveHorizontal } from "react-icons/bi";
import { BsDiagram3Fill,BsDiagram3, BsYinYang, BsGraphUpArrow, BsGraphDownArrow,BsUpcScan } from "react-icons/bs";
const registerComponents = ({ listKpis2 }) => {

let myComponent = [
    {
      name: "DailyTarget",
      icon: <Icon.Target />,
      size: 1,
      category:"Target",
      categoryIcon:<Icon.Target />
    },
    {
      name: "WeeklyTarget",
      icon: <Icon.Target />,
      size: 1,
      category:"Target",
      categoryIcon:<Icon.Target />
    },
    {
      name: "MonthlyTarget",
      icon: <Icon.Target />,
      size: 1,
      category:"Target",
      categoryIcon:<Icon.Target />
    },
    
    {
      name: "PieChart",
      icon: <Icon.PieChart />,
      category:"Charts",
      categoryIcon:<Icon.BarChart />,
      features: [
        {
          // "exports": {
          //     "dates": {
          //         "type": "dropdown",
          //         "options": ["today","yesterday","this_week"]

          //     },
          //     "compare1": {
          //         "type": "dropdown",
          //         "options": ["today","yesterday","this_week"]
          //     }
          // },
          // "kpis": {
          //     "type": "multiselect",
          //     "options": ["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          // }
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          },
          "exports": true
        }
      ]

    },
    // {
    //   name: "MixedChart",
    //   icon: <Icon.BarChart />,
    //   category:"Charts",
    //   categoryIcon:<Icon.BarChart />,
    //   features: [
    //     {
    //       "kpis": {
    //           "type": "multiselect",
    //           "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
    //       },
    //       "exports": true
    //     }
    //   ]
    // },
      
    {
      name: "PowerHour",
      icon: <Icon.BarChart />,
      category:"Charts",
      categoryIcon:<Icon.BarChart />,
      features: [
        {
          "kpis": {
              "type": "singleselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          },
          "exports": true
        }
      ]
    },
    {
      name: "LineChart",
      icon: <Icon.BarChart2 />,
      category:"Charts",
      categoryIcon:<Icon.BarChart2 />,
      features: [
        {
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          },
          "exports": true
        }
      ]

    },
 //
    {
      name: "RadarKpiDetails",
      icon: <Icon.BarChart />,
      category:"Radar&KpiCard",
      categoryIcon:<Icon.BarChart />,
      width:12,
      size:4,
    },
    {
      name: "AreaChart",
      icon: <Icon.BarChart />,
      category:"Charts",
      categoryIcon:<Icon.BarChart />,
      features: [
        {
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          },
          "exports": true
        }
      ]
    },
    {
      name: "DonutChart",
      icon: <Icon.BarChart />,
      category:"Charts",
      categoryIcon:<Icon.BarChart />,
      features: [
        {
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          },
          "exports": true
        }
      ]
    },
    //
    // {
    //   name: "BarChart",
    //   icon: <Icon.BarChart />,
    //   category:"Charts",
    //   categoryIcon:<Icon.BarChart />,
    //   features: [
    //     {
    //       "kpis": {
    //           "type": "multiselect",
    //           "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
    //       },
    //       "exports": true
    //     }
    //   ]
    // },
    // {
    //   name: "CandlestickChart",
    //   icon: <Icon.BarChart />,
    //   category:"Charts",
    //   categoryIcon:<Icon.BarChart />,
    //   features: [
    //     {
    //       "kpis": {
    //           "type": "multiselect",
    //           "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
    //       },
    //       "exports": true
    //     }
    //   ]
    // },
    // {
    //   name: "RadarChart",
    //   icon: <Icon.BarChart />,
    //   category:"Charts",
    //   categoryIcon:<Icon.BarChart />,
    //   features: [
    //     {
    //       "kpis": {
    //           "type": "multiselect",
    //           "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
    //       },
    //       "exports": true
    //     }
    //   ]
    // },

    {
      name: "KpiTable",
      icon: <Icon.Table />,
      category:"Tables",
      categoryIcon:<Icon.Table />,
      size:2,
      features: [
        {
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          }
        }
      ]
    },
    {
      name: "KpiCardsNew",
      icon: <Icon.Table />,
      category:"KpiCardsNew",
      categoryIcon:<Icon.Table />,
      size:2,
      features: [
        {
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          }
        }
      ]
    },
    {
      name: "TrendChartsNew",
      icon: <Icon.Table />,
      category:"TrendChartsNew",
      categoryIcon:<Icon.Table />,
      width:12,
      size:2,
      features: [
        {
          "kpis": {
              "type": "multiselect",
              "options": listKpis2//["gspv","gsor","gsoc","gspo","gssp","gsatc"]
          }
        }
      ]
    },

    
    // {
    //   name: "SalesTrendChart",
    //   icon: <MdAlignVerticalBottom />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    
  ];
  const getIcon = (name) => {
    if (name === "sls") {
      return <BiStats />;
    } else if (name === "trf") {
      return <BiTrendingUp />;
    } 
    else if (name === "trf_trf") {
      return <BiTrendingUp />;
    } else if (name === "tar") {
      return <BsDiagram3 />;
    }else if (name === "cn") {
      return <BiTransfer />;
    }else if (name === "aip") {
      return <BsDiagram3Fill />;
    }else if (name === "ap") {
      return <BsDiagram3 />;
    }else if (name === "cr") {
      return <BsYinYang />;
    }else if (name === "pb") {
      return <Icon.BarChart2 />;
    }else if (name === "spt") {
      return <BsGraphUpArrow />;
    }else if (name === "tpt") {
      return <BsGraphDownArrow />;
    } else if (name === "trn") {
      return <BsUpcScan />;
    } else if (name === "upt") {
      return <BiMoveHorizontal />;
    } else if (name === "se") {
      return <BsDiagram3Fill />;
    } else if (name === "sl") {
      return <BsYinYang />;
    } else if (name === "cs") {
      return <BsUpcScan />;
    } else {
      return <BiStats />;
    }
  }
  const getTrendIcon = (name) => {
    if (name === "sls") {
      return <MdAlignVerticalBottom />;
    } else if (name === "trf") {
      return <BiTrendingUp />;
    } else if (name === "trf_trf") {
      return <BiTrendingUp />;
    }
    else if (name === "tar") {
      return <BsDiagram3 />;
    }else if (name === "cn") {
      return <BiTransfer />;
    }else if (name === "aip") {
      return <BsDiagram3Fill />;
    }else if (name === "ap") {
      return <BsDiagram3 />;
    }else if (name === "cr") {
      return <BsYinYang />;
    }else if (name === "pb") {
      return <Icon.BarChart2 />;
    }else if (name === "spt") {
      return <BsGraphUpArrow />;
    }else if (name === "tpt") {
      return <BsGraphDownArrow />;
    } else if (name === "trn") {
      return <BsUpcScan />;
    } else if (name === "upt") {
      return <BiMoveHorizontal />;
    } else if (name === "se") {
      return <BsDiagram3Fill />;
    } else if (name === "sl") {
      return <BsYinYang />;
    } else if (name === "cs") {
      return <BsUpcScan />;
    } else {
      return <BiStats />;
    }
  }
  
  
  // var data = listKpis2?.map(name => ({
  //     name: name,
  //     icon: getIcon(name.trim()),//<BsGraphDownArrow />,
  //     category: "KpiCards",
  //     categoryIcon: <BiStats />
  // }));

  // {
  //   name: "SalesTrendChart",
  //   icon: <MdAlignVerticalBottom />,
  //   category:"TrendCharts",
  //   categoryIcon:<MdAlignVerticalBottom />,
  //   width:12,
  //   size:2,
  // },

//   var trendChartData = listKpis2?.map(name => ({
//     name: name,//"SalesTrendChart",//name,
//     icon: getTrendIcon(name.trim()),//<BsGraphDownArrow />,
//     category: "TrendCharts",//"KpiCards",
//     categoryIcon: <MdAlignVerticalBottom />,//<MdAlignVerticalBottom />,//<BiStats />,
//     width:12,
//     size:2,
// }));

  
  // myComponent = myComponent.concat(data);
  // myComponent = myComponent.concat(trendChartData);

  return myComponent;

};
  export default registerComponents;
  
   // {
    //   name: "AverageItemPriceTrendChart",
    //   icon: <BsDiagram3Fill />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "AveragePurchaseTrendChart",
    //   icon: <BsDiagram3 />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "CaptureRateTrendChart",
    //   icon: <BsYinYang />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "ClosingStrengthTrendChart",
    //   icon: <BsUpcScan />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "ConversionTrendChart",
    //   icon: <BiTransfer />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "PassersbyTrendChart",
    //   icon: <Icon.BarChart2 />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "RovTrendChart",
    //   icon: <Icon.BarChart />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "SalesPerTsuboTrendChart",
    //   icon: <BsGraphUpArrow />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "StaffEfficiencyTrendChart",
    //   icon: <BsDiagram3Fill />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "StaffHoursTrendChart",
    //   icon: <Icon.BarChart />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "StaffLevelTrendChart",
    //   icon: <BsYinYang />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "TARTrendChart",
    //   icon: <Icon.BarChart2 />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "TrafficPerTsuboTrendChart",
    //   icon: <BsGraphDownArrow />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "TrafficTrendChart",
    //   icon: <BiTrendingUp />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "TransactionsTrendChart",
    //   icon: <BsUpcScan />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
    // {
    //   name: "UptTrendChart",
    //   icon: <BiMoveHorizontal />,
    //   category:"TrendCharts",
    //   categoryIcon:<MdAlignVerticalBottom />,
    //   width:12,
    //   size:2,
    // },
   